import { Link } from 'react-router-dom'
import { Lock } from 'lucide-react'
import { NOT_IN_PACKAGES_MESSAGE } from '@/lib/instructorFeatures'

/**
 * R10-14 — no lugar de uma tela de /instructor cuja feature nao esta nos pacotes do
 * padrinho. A API recusa do mesmo jeito (403 `feature_not_in_package`).
 */
export default function InstructorFeatureBlocked() {
  return (
    <div className="mx-auto max-w-lg rounded-xl border border-neutral-700 bg-neutral-800/60 p-8 text-center" role="alert">
      <Lock className="mx-auto mb-3 h-8 w-8 text-neutral-400" aria-hidden />
      <h1 className="text-lg font-semibold text-white">Não incluído nos seus pacotes</h1>
      <p className="mt-2 text-sm text-neutral-400">
        {NOT_IN_PACKAGES_MESSAGE} Fale com a coordenação se você precisa deste acesso.
      </p>
      <Link to="/instructor/dashboard" className="mt-4 inline-block text-sm font-medium text-blue-400 hover:underline">
        Voltar ao dashboard
      </Link>
    </div>
  )
}
